import { render, staticRenderFns } from "./FieldsSubQuestion.vue?vue&type=template&id=0c97d47e&scoped=true"
import script from "./FieldsSubQuestion.vue?vue&type=script&lang=js"
export * from "./FieldsSubQuestion.vue?vue&type=script&lang=js"
import style0 from "./FieldsSubQuestion.vue?vue&type=style&index=0&id=0c97d47e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c97d47e",
  null
  
)

export default component.exports